export default __webpack_public_path__ + "static/zort-b4672d36ed1428575ad351e9443f88b8.png";